/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { mediaQuery } from 'utils/styles';
import { aniFrameCountdownBarInitial } from 'components/content/shared/questionset/shared/animations/frame_countdownbar/initial';
// import { aniFrameCountdownBarResult } from 'components/shared/questionset/animations/frame_countdownbar/result';
import { aniProgressBarShareTopInitial } from 'components/content/shared/questionset/shared/animations/progressbar_share_top/initial';
import { aniProgressBarShareTopResult } from 'components/content/shared/questionset/shared/animations/progressbar_share_top/result';
import { aniQuestionInitial } from 'components/content/shared/questionset/shared/animations/question/initial';
import { aniQuestionResult } from 'components/content/shared/questionset/shared/animations/question/result';
import {pxToEm} from "../../../../../utils/styles";



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// IMAGE 2 QUESTION TYPE STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    resultelements: {},
    answerset: {},
    typeset: {
        width: '100%',
        height: '100%',

        // ------ QUESTION ----- //
        '& .question': {
            transform: 'translate3d(-100%, 0, 0)', // pull off screen to start
            animationName: 'slideInLeft',
            animationDelay: '.1s',
            animationDuration: '.3s',
            animationFillMode: 'forwards'
        },

        // ------ ANSWER SET ----- //
        '& .answerset': {
            '& ul': {
                width: '100%',
                height: '80%',
                display: 'table',
                margin: '0 auto'
            },
            '& .answer': {
                display: 'table-cell',
                borderSpacing: '1%',
                verticalAlign: 'top',
                textAlign: 'center',
                height: '100%',

                opacity: '0',
                animationDuration: '.3s',
                animationFillMode: 'forwards',
                animationDelay: '1.1s',

                '&:hover': {
                    '& .graphic': {
                        animationName: 'pulse',
                        animationDelay: '0s',
                        animationDuration: '.5s'
                    }
                },
                '& .uniqueanswer': {
                    margin: '0 auto',
                    width: '92%'
                },

                '&:nth-child(1)': { animationName: 'fadeInRight' },
                '&:nth-child(2)': { animationName: 'fadeInLeft' },
                '&:nth-child(3)': { animationName: 'fadeInRight' },
                '&:nth-child(4)': { animationName: 'fadeInLeft' }
            },
            // amount of answers change the styles (ex 2 answers vs 4 answers)
            '&.answeramount-2': {
                '& .answer': {
                    width: '49%'
                }
            },
            '&.answeramount-3': {
                '& .answer': {
                    width: '32%'
                }
            },
            '&.answeramount-4': {
                fontSize: '85%',
                '& .answer': {
                    width: '25%'
                }
            }
        },

        // !!!!!!!!!!!!!!!!!!! ~~~~~~~~~~~~~~~~~~~~~~~ ANIMATIONS ~~~~~~~~~~~~~~~~~~~~~~~ !!!!!!!!!!!!!!!!!!! //
        extend: [aniProgressBarShareTopInitial],
        // *** INITIAL STATE *** //
        '&.initial': {
            extend: [aniFrameCountdownBarInitial, aniQuestionInitial]
        },
        // *** RESULT STATE *** //
        '&.result': {
            extend: [aniFrameCountdownBarInitial, aniQuestionResult, aniProgressBarShareTopResult],
            '& .answerset': {
                '& .answer': { transition: 'width .3s linear 0s' },
                '&.answeramount-2': {
                    '& .answer': {
                        width: '34%',
                        '&.selected-true': { width: '64%' }
                    }
                },
                '&.answeramount-3': {
                    '& .answer': {
                        width: '20%',
                        '&.selected-true': { width: '40%' }
                    }
                },
                '&.answeramount-4': {
                    '& .answer': {
                        width: '20%',
                        '&.selected-true': { width: '40%' }
                    }
                }
            }
        },
        // *** REWARDS STATE *** //
        '&.rewards': {
            // extend: [aniFrameCountdownBarResult, aniQuestionResult, aniProgressBarShareTopResult],

            '& .answerset, .resultelements, .question': {
                // removes text when shrinking the images
                display: 'none'
            },
            '& .rewardsmessage': { // This class name is in RewardsMessage component! It's a RewardsMessage wrapper div.
                display: 'block',
                width: '100%',
                height: '100%',
                opacity: '0', // pull off screen to start
                animationName: 'fadeIn',
                animationDelay: '0s',
                animationDuration: '.3s',
                animationFillMode: 'forwards'
            }
        }
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.wide]: {
        typeset: {
            '& .answerset': {
                paddingTop: '0 !important',
                paddingBottom: '0 !important',
                '&:.answeramount-2': {
                    '& ul': { width: '80%' }
                }
            }
        }
    },
    [mediaQuery.thin]: {
        typeset: {
            '& .answerset': {
                '& .answer': {
                    '& .uniqueanswer': {
                        height: '90%'
                    }
                }
            }
        }
    }
};
